"use client"

import type { ServiceGridListProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { ImageUploadField } from "../../../lib/ImageUploadField"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export const ServiceGridList: ComponentConfig<ServiceGridListProps> = {
  label: "Tamda OC | Service Grid List",
  fields: {
    title: {
      label: "Title",
      type: "text",
      placeholder: "DỊCH VỤ CHO THUÊ",
    },
    items: {
      label: "Items",
      type: "array",
      getItemSummary: (item: any, index = 0) => item?.text || item?.title || `Item ${index + 1}`,
      arrayFields: {
        image: {
          label: "Main Image",
          type: "custom",
          render: (props: any) => <ImageUploadField {...props} />,
        },
        text: {
          label: "Text",
          type: "text",
        },
        icon: {
          label: "Icon Image (Hover)",
          type: "custom",
          render: (props: any) => <ImageUploadField {...props} />,
        },
        title: {
          label: "Title (Hover)",
          type: "text",
        },
        description: {
          label: "Description (Hover)",
          type: "textarea",
        },
        link: {
          label: "Link (URL)",
          type: "text",
        },
        textHover: {
          label: "Text Hover (Deprecated)",
          type: "textarea",
        },
      },
      defaultItemProps: {
        image: "",
        text: "",
        icon: "",
        title: "",
        description: "",
        textHover: "",
        link: "",
      },
    },
    ...(commonStylesProps as any),
  },
  defaultProps: {
    title: "DỊCH VỤ CHO THUÊ",
    items: [],
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
}

export type { ServiceGridListItem, ServiceGridListProps } from "@/types/types"
